const o = (d, n) => {
  d.addEventListener("keydown", (e) => {
    ["Escape"].includes(e.key) && n.value(e);
  });
}, a = {
  created: o,
  bind: o
}, t = (d, n) => {
  d.addEventListener("keydown", (e) => {
    ["Enter", " "].includes(e.key) && n.value(e);
  }), d.addEventListener("click", (e) => {
    e.stopPropagation(), e.preventDefault(), n.value(e);
  });
}, c = {
  created: t,
  bind: t
};
export {
  a as DropdownClose,
  c as DropdownOpen
};
